<script setup lang="ts">
import { computed } from 'vue'
import { parseDescriptionMarkdown, type DescriptionRenderMode } from '@/utils/markdown'

const props = withDefaults(defineProps<{
  markdown: string
  mode?: DescriptionRenderMode
}>(), {
  mode: 'full',
})

const html = computed(() => parseDescriptionMarkdown(props.markdown || '', props.mode))
</script>

<template>
  <div v-if="markdown" v-html="html"></div>
</template>
